

export default (app)=>{
    app.directive('focus',{
        mounted(el) {
            el.focus()
          }
    })

    app.directive('hasPerm', {
        mounted(el, binding, vnode){
            const { value } = binding
            const userInfo = JSON.parse(localStorage.getItem('userInfo'))
            const permsList  = userInfo.permsList;
            if(!permsList.includes(value)){
                el.parentNode && el.parentNode.removeChild(el)
            }

        }
    })    

}